import { useTranslation } from "@chr/online-shared-ui-localizations";
import { DrawerSuccessSummary } from "@/common/components/side-drawer/DrawerSuccessSummary";
import { Box, Stack } from "@mui/material";
import { Typography } from "@chr/eds-react";
import { Document } from "@/common/apis/dtos";
import { getDocumentTypeDisplayName } from "@/common/utilities/display-utilities";
import { ShowMoreText } from "@/common/components/show-more-text/ShowMoreText";

export interface EmailDocumentSuccessProps {
  emailToValues: string[];
  messageValue: string;
  documents: Document[];
  onAgain: () => void;
}

// ✅ Reusable section layout
const SummarySection = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <Box>
    <Typography variant="subtitle200">{title}</Typography>
    <Box mt={0.5}>{children}</Box>
  </Box>
);

export const EmailDocumentSuccess = ({
  emailToValues,
  messageValue,
  documents,
  onAgain,
}: EmailDocumentSuccessProps) => {
  const translate = useTranslation();

  return (
    <DrawerSuccessSummary
      title={translate('Email on its way')}
      subTitle={translate('Your email request has been submitted and will be sent shortly. You can close this panel or use the button bellow to share with another email address.')}
      againButtonText={translate('Share again')}
      onAgain={onAgain}
    >
      <Stack spacing={2} overflow="clip">
        <SummarySection title={translate("Email To")}>
          {emailToValues.map((email, index) => (
            <Typography variant="body200" key={index}>
              {email}
            </Typography>
          ))}
        </SummarySection>
        <Box>
          <Typography variant="subtitle200">{translate('Message')}</Typography>
          <ShowMoreText variant="body2" text={messageValue || '-'}/>
        </Box>
        <Box>
          <Typography variant="subtitle200">{translate('Attachment')}</Typography>
          { documents.map( document =>
            <Typography variant="body200" key={document.id}>
              {`${document.name} - ${translate(getDocumentTypeDisplayName(document.type))}`}
            </Typography>
          )}
        </Box>
      </Stack>
    </DrawerSuccessSummary>
  );
}
